import "./css/animate.css";
import "./css/bootstrap.min.css";
import "./css/jquery.fancybox.min.css";
import "./css/jqueryui.min.css";
import "./css/swiper-bundle.min.css";
import "./css/styles.css";
import "./fonts/font-icons.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./assets/styles.scss";
import "./fonts/font-icons.css";
import "./fonts/fonts.css";

import "photoswipe/dist/photoswipe.css";
import "react-modal-video/scss/modal-video.scss";
import "rc-slider/assets/index.css";
import WOW from "./utlis/wow";
import { Route, Routes, useLocation } from "react-router-dom";
import Home from "./pages";
import HomePage2 from "./pages/homes/home-02";
import HomePage3 from "./pages/homes/home-03";
import HomePage4 from "./pages/homes/home-04";
import HomePage5 from "./pages/homes/home-05";
import HomePage6 from "./pages/homes/home-06";
import { useEffect } from "react";
import LoginModals from "./components/modals/LoginModals";
import Register from "./components/modals/Register";
import BackToTop from "./components/common/BackToTop";
import ScrollTopBehaviour from "./components/common/ScrollTopBehaviour";
import PropertyHalfmapGridPage from "./pages/properties/property-halfmap-grid";
import PropertyHalfmapListPage from "./pages/properties/property-halfmap-list";
import TopmapGridPage from "./pages/properties/topmap-grid";
import TopmapListPage from "./pages/properties/topmap-list";
import SidebarGridPage from "./pages/properties/sidebar-grid";
import SidebarListPage from "./pages/properties/sidebar-list";
import PropertyDetailsPageV1 from "./pages/property-details/property-details-v1";
import PropertyDetailsPageV2 from "./pages/property-details/property-details-v2";
import PropertyDetailsPageV3 from "./pages/property-details/property-details-v3";
import PropertyDetailsPageV4 from "./pages/property-details/property-details-v4";
import AboutUsPage from "./pages/other-pages/about-us";
import OurServicePage from "./pages/other-pages/our-service";
import PricingPage from "./pages/other-pages/pricing";
import ContactPage from "./pages/other-pages/contact";
import FaqPage from "./pages/other-pages/faq";
import PrivacyPolicyPage from "./pages/other-pages/privacy-policy";
import BlogPage from "./pages/blogs/blog";
import BlogGridPage from "./pages/blogs/blog-grid";
import BlogDetailsPage from "./pages/blogs/blog-detail";
import DashboardPage from "./pages/dashboard/dashboard";
import MyPropertyPage from "./pages/dashboard/my-property";
import MessagePage from "./pages/dashboard/message";
import MyFavoritePage from "./pages/dashboard/my-favorites";
import ReviewPage from "./pages/dashboard/reviews";
import MyProfilePage from "./pages/dashboard/my-profile";
import AddPropertyPage from "./pages/dashboard/add-property";
import BuySubscription from "./components/dashboard/BuySubscription";
import ManageEnquiry from "./pages/dashboard/ManageEnquiry.js";
import Profile from "./components/BloggerProfile/Profile.js";
import AddPhotos from "./components/dashboard/AddPhotos.jsx";
import AddAmenities from "./components/dashboard/AddAmenities.jsx";
import AddFloorPlan from "./components/dashboard/AddFloorPlan.jsx";
import AddDocument from "./components/dashboard/AddDocument.jsx";
import AddNearAmenities from "./components/dashboard/AddNearAmenities.jsx";
import Error404 from "./components/Error404";
import Website from "./Schema/Website.js";
import Webpage from "./Schema/Webpage.js";
import OrganizationSchema from "./Schema/organizationSchema.js";
import LocalBusiness from "./Schema/LocalBusiness.js";
import Faq from "./Schema/Faq";
import SearchResultPageSchema from "./Schema/SearchResultPageSchema";
import ServiceSchema from "./Schema/ServiceSchema";
import RealEstateListingSchema from "./Schema/RealEstateListingSchema.js";
import Breadcrumb from "./Schema/Breadcrumb.js";
import { SnackbarProvider } from "notistack";
import DeveloperModeOnOff from "./components/DeveloperModeOnOff";
import { HelmetProvider } from "react-helmet-async";

function App() {
  const { pathname } = useLocation();
  const isHomeRoute = pathname === "/" || pathname === "/home";

  useEffect(() => {
    if (typeof window !== "undefined") {
      // Import the script only on the client side
      import("bootstrap/dist/js/bootstrap.esm").then(() => {
        // Module is imported, you can access any exported functionality if
      });
    }
  }, []);

  useEffect(() => {
    const wow = new WOW({
      mobile: false,
      live: false,
    });
    wow.init();
  }, [pathname]);

  useEffect(() => {
    document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove());
    const body = document.body;
    body.classList.remove("modal-open");
    body.style.removeProperty("overflow");
    body.style.removeProperty("padding-right");
  }, [pathname]);

  return (
    <>
      <HelmetProvider>
        <DeveloperModeOnOff />
        <SnackbarProvider
          maxSnack={3}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
        >
          <div id="wrapper">
            <div id="pagee" className="clearfix">
              <OrganizationSchema />
              <RealEstateListingSchema />
              <LocalBusiness />
              <Website />
              <Webpage />
              <Faq />
              <ServiceSchema />
              <Breadcrumb />
              <SearchResultPageSchema />
              <Routes>
  {/* <Route index element={<Home />} />
                <Route path="home-03" element={<HomePage3 />} />
                <Route path="home-04" element={<HomePage4 />} />
                <Route path="home-05" element={<HomePage5 />} />
                <Route path="home-06" element={<HomePage6 />} />
                <Route
                  path="property-halfmap-grid"
                  element={<PropertyHalfmapGridPage />}
                />
                <Route
                  path="property-halfmap-list"
                  element={<PropertyHalfmapListPage />}
                />
                <Route path="topmap-grid" element={<TopmapGridPage />} />
                <Route path="topmap-list" element={<TopmapListPage />} />
                
                <Route path="sidebar-list" element={<SidebarListPage />} />
                <Route
                  path="property-details-v1/:id"
                  element={<PropertyDetailsPageV1 />}
                />
               
                <Route
                  path="property-details-v3"
                  element={<PropertyDetailsPageV3 />}
                />
                <Route
                  path="property-details-v4"
                  element={<PropertyDetailsPageV4 />}
                />
                <Route path="about-us" element={<AboutUsPage />} />
                <Route path="our-service" element={<OurServicePage />} />
                <Route path="pricing" element={<PricingPage />} />
                <Route path="contact" element={<ContactPage />} />
                <Route path="faq" element={<FaqPage />} />
                <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
                <Route path="blog" element={<BlogPage />} />
                <Route path="blog-grid" element={<BlogGridPage />} />
                <Route path="blog-detail/:id" element={<BlogDetailsPage />} />
                <Route path="dashboard" element={<DashboardPage />} />
                <Route path="my-property" element={<MyPropertyPage />} />
                <Route path="message" element={<MessagePage />} />
                <Route path="my-favorites" element={<MyFavoritePage />} />
                <Route path="reviews" element={<ReviewPage />} />
                <Route path="my-profile" element={<MyProfilePage />} />
                <Route path="add-property" element={<AddPropertyPage />} />
 */}

                <Route path="/">
                  <Route index element={<HomePage2 />} />
                  <Route path="/" element={<HomePage2 />} />
                  <Route path="home" element={<HomePage2 />} />
                  <Route path=":title" element={<SidebarGridPage />} />
                  <Route
                    path="property-details/:title"
                    element={<PropertyDetailsPageV2 />}
                  />

                  <Route path="contact-us" element={<ContactPage />} />
                  <Route
                    path="privacy-policy"
                    element={<PrivacyPolicyPage />}
                  />
                  <Route path="about-us" element={<AboutUsPage />} />
                  <Route path="our-services" element={<OurServicePage />} />
                  <Route path="author/:title" element={<Profile />} />
                  <Route path="blog-grid" element={<BlogGridPage />} />
                  <Route
                    path="blog-detail/:title"
                    element={<BlogDetailsPage />}
                  />
                  {/* <Route path="faq" element={<FaqPage />} /> */}
                  <Route path="404" element={<Error404 />} />
                  <Route path="*" element={<Error404 />} />
                </Route>

                {/* VendorLogin */}
                <Route path="dashboard" element={<DashboardPage />} />
                <Route path="add-property" element={<AddPropertyPage />} />

                <Route path="add-photos" element={<AddPhotos />} />
                <Route path="add-amenities" element={<AddAmenities />} />
                <Route path="add-floor-plan" element={<AddFloorPlan />} />
                <Route path="add-document" element={<AddDocument />} />
                <Route
                  path="add-near-amenities"
                  element={<AddNearAmenities />}
                />

                <Route path="my-profile" element={<MyProfilePage />} />
                <Route path="buy-subscription" element={<BuySubscription />} />
                <Route path="manage-enquiry" element={<ManageEnquiry />} />
              </Routes>
            </div>
          </div>

          <LoginModals />
          <Register />
          <BackToTop />
          <ScrollTopBehaviour />
        </SnackbarProvider>
      </HelmetProvider>
    </>
  );
}

export default App;
